import {Row, Spinner} from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import {useInfiniteQuery} from 'react-query'
import {getVideos} from '../../api/videos'
import {useContext, useMemo, useState} from 'react'
import { AppContext } from '../../context'
import { approveVideo } from '../../api/videos'
import AdminRejectedVideoCard from '../../components/AdminRejectedVideoCard'

const AdminRejectedVideos = () => {
  const { token } = useContext(AppContext)
  const [loading, setLoading] = useState(false)
  const { data, isFetching, hasNextPage, fetchNextPage, refetch } =
    useInfiniteQuery(
      ['rejected_videos', token],
      ({ pageParam = 1 }) =>
        getVideos({ 
          page: pageParam, 
          status: 'Rejected',
          all: 'true',
          per_page: 12, 
        }, token),
      {
        getNextPageParam: (lastPage) =>
          lastPage.actual_page < lastPage.total_pages
            ? Number(lastPage.actual_page) + 1
            : false,
        initialData: { pages: [{ data: [] }], pageParams: 1 },
        enabled: token !== '',
      }
    )
  const videos = useMemo(
    () =>
      data.pages.reduce((prevVideos, page) => prevVideos.concat(page.data), []),
    [data]
  )

  const pendingVideo = (videoid) => { 
    const body = {
      status : 'Pending',
    }
    approveVideo(token, videoid, body)
      .then(() => {
        setLoading(true)
        refetch()
        setLoading(false)
      })
  }

  return (
    <>
      {token === '' || isFetching || loading ? (
        <div className="text-center" style={{ marginBottom: '49.25px' }}>
          <Spinner animation="border" variant="warning" />
        </div>
      ) : videos.length === 0 ? (
        <div>No rejected videos</div>
      ) : (
        <Row className="mb-4">
          {videos.length !== 0 ? videos.map((video) =>
            <AdminRejectedVideoCard
              video={video}
              key={video.id}
              pendingVideo={pendingVideo}
              id={video.id}
              socialNet={video.hosted_in}
              likes={video.votes}
              name={video.name}
              videoName={video.name}
              videoSrc={video.video_link}
              firstName={video.user_name}
              lastName={video.user_last_name}
              description={video.description}
              staffPick={video.is_staff_pick}
              recommended={video.recommended}
              image={video.thumbnail}
              email={video.user_email}
              age={video.user_age}
              mobile={video.user_phone}
              city={video.user_city}
              country={video.user_country}
              voted={video.already_voted}
            />
          ): <></>}
        </Row>
      )}
      {hasNextPage? 
        <div className="text-center mb-5" onClick={() => fetchNextPage()}>
          <Button variant="rs-third">Load more videos</Button>
        </div>
        : null
      } 
    </>
  )
}

export default AdminRejectedVideos
